import { QueryClient } from "@tanstack/react-query";

import { QUERY_CLIENT_DEFAULTS } from "@/lib/queryRetry";

// ============================================================================
// The app's QueryClient — constructed HERE, not in `main.tsx`, so that the
// object under test is the object that is wired.
//
// Two earlier attempts at guarding this did not. The retry policy started
// inline in `main.tsx`, unreachable by any test. Extracting the OPTIONS object
// was not enough either: `main.tsx` still did the construction, so a
// reviewer's mutation reverting it to `retry: 3` left the entire suite green.
// Asserting on an options object only proves the library agrees with itself.
//
// Exporting the INSTANCE closes it. `main.tsx` can no longer pass different
// options without deleting this import, and `queryClient.test.ts` reads the
// defaults off the very client the app renders with.
// ============================================================================

export const queryClient = new QueryClient({
  defaultOptions: QUERY_CLIENT_DEFAULTS,
});
